import { Button, Paper, Popper, Stack, Typography } from '@mui/material';
import { Provider, type AwsVpcConnectivityConfig } from '@repo/api-gw-sdk';
import { useEffect, useState } from 'react';

import { RestoreRegionSelect } from '@/components/selectors/restoreRegionSelect';
import { VpcSelect } from '@/components/selectors/vpcSelect';

export const VpcSelectionDialog = ({
  accountId,
  onClose,
  anchorEl,
  config,
}: {
  accountId: string;
  onClose: (regionName: string | undefined, vpc: string | undefined) => void;
  anchorEl: HTMLElement | null;
  config: AwsVpcConnectivityConfig[];
}) => {
  const [regionName, setRegionName] = useState<string | undefined>('us-east-1');
  const [vpc, setVpc] = useState<string | undefined>(undefined);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setVpc(undefined);
  }, [regionName]);

  return (
    <Popper anchorEl={anchorEl} disablePortal placement='bottom-start' open>
      <Paper
        sx={{
          width: '308px',
          padding: '24px',
          borderRadius: '4px',
          marginTop: '-33px',
          boxShadow: 'var(--mui-customShadows-lg)',
        }}
      >
        <Stack gap='24px'>
          <Typography>Choose a VPC</Typography>
          <RestoreRegionSelect
            restoreAccountId={accountId}
            regionName={regionName}
            onChange={(regionName) => setRegionName(regionName)}
            cloudProvider={Provider.Aws}
          />
          <VpcSelect
            disabledItems={config
              .filter((x) => x.region === regionName)
              .map((c) => c.vpc)}
            vpc={vpc}
            regionName={regionName}
            accountId={accountId}
            onChange={setVpc}
          />
          <Stack direction='row' gap='8px' justifyContent={'flex-end'}>
            <Button onClick={() => onClose(undefined, undefined)}>
              Cancel
            </Button>
            <Button
              onClick={() => onClose(regionName, vpc)}
              variant='contained'
              disabled={!regionName || !vpc}
            >
              Customize VPC
            </Button>
          </Stack>
        </Stack>
      </Paper>
    </Popper>
  );
};
